<template>
  <div class="handleDetail" style="margin-top: 1%">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick">
      <el-tab-pane label="图形显示">
        <div v-if="diagramReady" id="workflowDIV" style="height: 400px; padding: 10px"/>
        <div style="display: flex; flex-direction: row; align-items: center; margin: -60px auto 0 auto; width: 750px">
          <div style="display: flex; flex-direction: row; align-items: center">
            <div style="width: 100px; height: 30px; background: #ff9900"/>
            <div style="font-size: 14px; color: #333; margin-left: 10px">待处理</div>
          </div>
          <div style="margin-left: 30px; display: flex; flex-direction: row; align-items: center">
            <div style="width: 100px; height: 30px; background: #00a9c9"/>
            <div style="font-size: 14px; color: #333; margin-left: 10px">已处理</div>
          </div>
          <div style="margin-left: 30px; display: flex; flex-direction: row; align-items: center">
            <div style="width: 100px; height: 30px; background: red"/>
            <div style="font-size: 14px; color: #333; margin-left: 10px">退回</div>
          </div>
          <div style="margin-left: 30px; display: flex; flex-direction: row; align-items: center">
            <div style="width: 100px; height: 30px; background: #999999"/>
            <div style="font-size: 14px; color: #333; margin-left: 10px">待定或跳过</div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="列表显示">
        <div v-for="(item, index) in model.handleDetailVos" :key="index" class="listDisplay">
          <div style="width: 100%; display: flex; flex-direction: row; -webkit-align-content: center; align-items: center">
            <div class="listDisplay-first">
              <div>{{item.nodeText}}</div>
            </div>
            <div class="listDisplay-first">
              <div v-if="item.handleResult === 0">
                <span v-for="(items,index) in item.nodeApproverVos" :key="index" class="listDisplay-first-name">
                  {{items.handlerName + ";"}}
                </span>
              </div>
              <div v-else>{{item.handlerName}}</div>
            </div>
            <div class="listDisplay-second" style="width: calc(100vw - 880px)">
              <div v-if="item.applicationAttacheds.length === 0" style="line-height: 60px" class="listDisplay-second-top">
                {{item.handleRemark}}
              </div>
              <div v-else class="listDisplay-second-top">{{item.handleRemark}}</div>
              <div class="listDisplay-second-bottom">
                <div v-if="item.applicationAttacheds.length === 0" style="display: none">附件：</div>
                <div v-else>附件:</div>
                <ul>
                  <li v-for="applicationAttached in item.applicationAttacheds" :key="applicationAttached">
                    <span v-if="(applicationAttached.category === 1 && ctrlAuth) || applicationAttached.category === 0">
                      <a @click="downloadExcel(applicationAttached)">{{applicationAttached.fileName}}</a>
                      <img src="../../../public/img/attached.png" class="attached">
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="listDisplay-third">
              <div v-if="item.handleResult === 0">
                <img src="../../../public/img/processing.png">
              </div>
              <div v-if="item.handleResult === 1">
                <img src="../../../public/img/agree.png">
              </div>
              <div v-if="item.handleResult === 3">
                <img src="../../../public/img/return.png">
              </div>
              <div v-if="item.handleResult === 4">
                <img src="../../../public/img/assign.png">
              </div>
              <div v-if="item.handleResult === 5">
                <img src="../../../public/img/distribution.png">
              </div>
              <div v-if="item.handleResult !== 0">处理时间：{{item.handleTime}}</div>
            </div>
            <div class="listDisplay-fourth">
              <div>标准用时：{{item.standardTime}}</div>
              <!--<div>实际用时：<span>剩余处理时间{{item.actualTime}}</span></div>-->
              <div>到达时间：{{item.createdTime}}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="流程附件">
        <div v-if="sequId !== '-1'">
          <el-upload
              v-if="ctrlAuth"
              action=""
              multiple
              :http-request="submitUpload1"
              :show-file-list="false"
              :disabled="uploadLoading1"
              style="display: inline-block; float: right; margin: 5px"
          >
            <el-button type="primary" plain><i class="el-icon-upload el-icon--right"/>受控附件上传</el-button>
          </el-upload>
          <el-upload
              action=""
              multiple
              :http-request="submitUpload"
              :show-file-list="false"
              :disabled="uploadLoading"
              style="display: inline-block; float: right; margin: 5px"
          >
            <el-button type="primary" plain><i class="el-icon-upload el-icon--right"/>附件上传</el-button>
          </el-upload>
        </div>
        <el-table :data="attachedList" style="width: 100%">
          <el-table-column prop="nodeDesc" label="节点名称" align="center" width="160"/>
          <el-table-column prop="category" label="文件分类" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.category === 0">自制附件</span>
              <span v-if="scope.row.category === 1">外购附件</span>
              <span v-if="scope.row.category === 2">电缆附件</span>
              <span v-if="scope.row.category === 4">确认图纸</span>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="left" label="文件名"/>
          <el-table-column prop="creatorAccountName" align="center" label="创建者" width="100"/>
          <el-table-column prop="createdTime" align="center" width="160" label="创建时间"/>
          <el-table-column prop="note" align="center" label="备注"/>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                  v-if="scope.row.creatorID === userId && sequId !== '-1'"
                  type="primary"
                  @click="$refs.editPage.open(scope.row.id)">
                备注
              </el-button>
              <el-button
                  v-if="(scope.row.category ===0 && ziZhiFuJianDownLoadAuth) ||
                    (scope.row.category ===1 && waiGouFuJianDownLoadAuth) ||
                    (scope.row.category ===2 && dianLanFuJianDownLoadAuth) ||
                    (scope.row.category ===4 && queRenTuZhiDownLoadAuth)"
                  type="primary"
                  @click="downloadExcel(scope.row)">
                下载
              </el-button>
              <el-button
                  v-if="scope.row.creatorID === userId && sequId !== '-1'"
                  type="danger"
                  @click="handleDelete(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <edit-page ref="editPage" @save-success="getFileData()"/>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import editPage from "@/views/workFlow/AttachedNoteEdit";

  export default {
    name: "",
    components: { editPage },
    props: {
      billId: {
        type: [String, Number],
        required: true,
        default: "",
      },
      billType: {
        type: [String, Number],
        required: true,
      },
      sequId: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        activeName: "0",
        diagramReady: false,
        diagramInited: false,
        uploadLoading: false,
        uploadLoading1: false,
        userId: loginUtil.getUserId(),
        ctrlAuth: this.$auth(18),
        ziZhiFuJianDownLoadAuth:this.$auth(336),
        waiGouFuJianDownLoadAuth:this.$auth(343),
        dianLanFuJianDownLoadAuth:this.$auth(350),
        queRenTuZhiDownLoadAuth:this.$auth(356),
        attachedList: [],
        model: {
          gojsData: "",
          handleDetailVos: [],
        },
        approveInitial: {},
      };
    },
    mounted() {
      if (this.sequId !== "-1") {
        this.getBaseData();
      }
      this.getData();

      this.getFileData();
    },
    methods: {
      getData() {
        this.$http
          .get("basic", `applications/handle-detail/${this.billType}/${this.billId}`)
          .then((resp) => {
            this.model = resp;
            this.$emit("getNode", this.model);
            // 数据返回后再渲染画布容器，确保 GoJS 初始化时元素已存在且有尺寸
            this.diagramReady = true;
          })
          .then(() => {
            this.initWorkFlowDiagram();
          });
      },
      getBaseData() {
        let params = {
          billType: this.billType,
          billId: this.billId,
          sequId: this.sequId,
        };
        this.$http.get("basic", "applications/approve", params).then((resp) => {
          this.approveInitial = resp;
        });
      },
      getFileData() {
        this.$http.get("basic", `applications/attached/${this.billType}/${this.billId}`).then((resp) => {
          console.log(resp);
          this.attachedList = resp;
        });
      },
      initWorkFlowDiagram() {
        // 等待画布容器渲染完成、尺寸就绪后再初始化，避免 Diagram 尺寸为 0 导致图形不可见
        this.$nextTick(() => {
          const container = document.getElementById("workflowDIV");
          if (!container) {
            return;
          }
          // 同一个 div 只能关联一个 Diagram，已初始化过就不再重复创建
          if (this.diagramInited) {
            // eslint-disable-next-line no-undef
            if (window.myDiagram) {
              // eslint-disable-next-line no-undef
              window.myDiagram.requestUpdate();
            }
            return;
          }
          // 容器尚未获得尺寸（如处于隐藏的 Tab 中），延迟重试，直至可见
          if (container.clientWidth === 0 || container.clientHeight === 0) {
            setTimeout(() => {
              this.initWorkFlowDiagram();
            }, 100);
            return;
          }
          this.diagramInited = true;
          // eslint-disable-next-line no-undef
          const workflow = new _workflow(this.model.gojsData, "workflowDIV");
          workflow.init();
        });
      },
      handleTabClick(tab) {
        // 切换到图形显示 Tab 时，容器由 display:none 变为可见，需要重新布局
        if (tab.index === "0" || tab.name === "0") {
          this.$nextTick(() => {
            // 若此前因容器不可见一直未初始化，此处触发初始化
            if (!this.diagramInited) {
              this.initWorkFlowDiagram();
              return;
            }
            // eslint-disable-next-line no-undef
            const diagram = window.myDiagram;
            if (diagram) {
              diagram.requestUpdate();
            }
          });
        }
      },
      downloadExcel(row) {
        //console.log("............." + window.config.fileServerUrl   + row.filePath);
        let a = document.createElement("a");
        a.href = window.config.fileServerUrl + row.filePath;
        a.target="_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            this.saveAttachments(res.data.attachments, 0);
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      submitUpload1(params) {
        this.uploadLoading1 = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/1", formData)
          .then((res) => {
            this.uploadLoading1 = false;
            this.saveAttachments(res.data.attachments, 1);
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading1 = false;
            this.$message.error("上传失败");
          });
      },
      saveAttachments(rowList, category) {
        for (let item of rowList) {
          item.billType = this.billType;
          item.billId = this.billId;
          item.applID = this.approveInitial.applId;
          item.nodeID = this.approveInitial.nodeId;
          item.nodeDesc = this.approveInitial.nodeDesc;
          item.category = category;
        }
        this.$http
          .post("basic", "applications/attached", rowList)
          .then(() => {
            this.getFileData();
            console.log("保存附件成功");
            // this.$message.success("保存附件成功");
          })
          .catch(() => {
            console.log("保存附件失败");
            // this.$message.error("保存附件失败");
          });
      },
      handleDelete(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "applications/attached", row.id).then(() => {
            this.getFileData();
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style scoped>
.listDisplay {
  width: 100%;
  padding: 5px 0;
  border-bottom: 1px solid #f5f5f5;
}
/*first*/
.listDisplay .listDisplay-first {
  width: 220px;
  border-right: 1px dashed #dddddd;
}
.listDisplay .listDisplay-first div {
  /* width: 100%; */
  text-align: center;
  font-size: 12px;
}
/*second*/
.listDisplay .listDisplay-second div:first-child {
  text-align: left;
}
.listDisplay .listDisplay-second {
  height: 80px;
  font-size: 12px;
  /*border-right: 1px dashed #dddddd;*/
  position: relative;
  padding: 0 0 0 10px;
}
.listDisplay .listDisplay-second div:last-child {
  width: 100%;
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  text-align: left;
  position: absolute;
  bottom: 0;
}
.listDisplay .listDisplay-second div:last-child div {
  width: 40px;
}
.listDisplay .listDisplay-second ul {
  width: 85%;
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.listDisplay .listDisplay-second ul li {
  list-style: none;
  margin-right: 2%;
  font-size: 12px;
}
.listDisplay .listDisplay-second ul li img {
  width: 12px;
}
/*third*/
.listDisplay-third {
  width: 280px;
  height: 60px;
  font-size: 12px;
  border-right: 1px dashed #dddddd;
  padding-right: 10px;
}
.listDisplay-third div:first-child img {
  width: 50px;
  display: block;
  margin: 0 auto;
}
.listDisplay-third div {
  width: 100%;
  margin-top: 1%;
  text-align: center;
}
/*fourth*/
.listDisplay-fourth {
  width: 300px;
  padding-left: 10px;
  font-size: 12px;
}
.listDisplay-fourth div {
  width: 100%;
  text-align: left;
}
.listDisplay-fourth div:nth-child(1) {
  margin-bottom: 10px;
}
.listDisplay-fourth div:nth-child(2) span {
  color: #b70000;
}
</style>
